/**
 * 이름: webCategory.js
 * 설명: 웹 카테고리에 관련된 API를 정의한다.
 */

export const state = () => ({
  webCategoryDetailApi: '/api/op/webcategory/objects',
  webCategoryDetailInfo: {}
})

export const mutations = {
  setWebCategoryDetailInfo (state, detailInfo) {
    state.webCategoryDetailInfo = detailInfo
  }
}

export const actions = {
  /**
   * 이름: getDetailWebCategory
   * 설명: 웹 카테고리 정보가 있는 경우 상세 정보를 조회한다.
   */
  async getDetailWebCategory ({state, commit}, webCateId) {
    let res = { code: 'ok', result: {} } // TAMS

    try {
      res = await this.$axios.$get(`${state.webCategoryDetailApi}/${webCateId}`)

      if (res.code === 'ok') {
        commit('setWebCategoryDetailInfo', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  }
}
